// extracted by mini-css-extract-plugin
export default {"left":"styles-module__left__src-labstep-web-core-Select-_RDP_B"};